import { imgs } from '../../assets/imgs';
import { tracking } from '../../utils/tracking';

const cards = [
   {
      title: 'Brand Exposure',
      tittleColor: '#0256dd',
      content1: 'Selected startups will pitch to VCs, corporate VCs, angel investors, industry executives, decision-makers, press, and corporate development officers.',
      content2: 'The Venture Summit will help you get noticed by the right people and drive brand awareness at an accelerated rate.',
      img: imgs.startups.brandExposure,
   },
   {
      title: 'Immersive Learning',
      tittleColor: '#028ddd',
      content1: 'Attending panels and participating in workshops on the main stage will impart valuable insight into the do’s and don’ts of scaling your business.',
      content2: 'Learn from leading investors and successful tech professionals, and leading business development executives.',
      img: imgs.startups.immersiveLearning,
   },
   {
      title: 'Smart Money',
      tittleColor: '#02b9dd',
      content1: 'Beyond the money, Investors that attend the Venture Summit bring years of expertise, wide networks, and massive support infrastructure. These investors advise their startups and are dedicated to seeing them succeed.',
      content2: '',
      img: imgs.startups.smartMoney,
   },
   {
      title: 'Exclusive Networking',
      tittleColor: '#02D8DD',
      content1: ' Networking opportunities are built into the entirety of the Venture Summit. Start networking before the event with the dedicated matchmaking app – reach out to investors, professionals in your field of expertise, and find potential leads.',
      content2: '',
      img: imgs.startups.exclusiveNetworking,
   },
];
export const StartupGaining = () => {
   return (
      <div className='startup-gaining'>
         <h1 >What you get from the <span> Venture Summit</span></h1>
         <section className='cards'>
            {
               cards.map((card, cardIdx) =>
                  <div key={cardIdx} className='card'>
                     <div className='card-inner'>
                        <div className='front'>
                           <img src={card.img} alt={`${card.title}, image`} width={'100%'} />
                           <h3>{card.title}</h3>
                        </div>
                        <div className='back'>
                           <p>{card.content1}</p>
                           <p>{card.content2}</p>
                        </div>
                     </div>
                  </div>
               )
            }

         </section>
         <section className='button-section'>
            <a className='btn' rel='noreferrer' href='https://account.youngstartup.com' onClick={() => tracking(285)} >APPLY NOW</a>
         </section>
      </div>
   )
}
